import { OpportunitiesContext } from 'pages/Opportunities/context/OpportunitiesContext';
import React, { useEffect, useMemo, useState } from 'react';
import { useContextSelector } from 'use-context-selector';
import { AgeRangeButton, FilterCont, FilterSelect } from './OpportunitiesFilter.styles';
import { Checkbox, Grid, InputAdornment, ListItemText, MenuItem, Paper, Select, useTheme } from '@material-ui/core';
import { SelectArrowDownIcon } from '@room-match/shared-ui-components';
import { COLORS } from 'shared/constants/COLORS';
import gender from 'data/Gender.json';
import { CustomTypography } from 'shared/elements/CustomTypography';
import AgePopOver from './AgePopOver';
import Locs from 'data/Locations.json';
import { Autocomplete, AutocompleteRenderGroupParams } from '@material-ui/lab';
import unionList from 'data/Unions.json';
import jobType from 'data/JobType.json';
interface Location {
  [key: string]: { [key: string]: string[] }[];
}
interface CityOption {
  state: string;
  city: string;
}

const OpportunitiesFilter = () => {
  const isDark = useTheme().palette.type === 'dark';
  const locationData: Location = Locs as any;

  const filters = useContextSelector(OpportunitiesContext, (state) => state.filters);
  const setFilters = useContextSelector(OpportunitiesContext, (state) => state.setFilters);
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);

  const open = Boolean(anchorEl);
  const openAgeRange = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const cityOptions = useMemo(() => {
    return (
      locationData[filters.countries]
        ?.flatMap(Object.entries)
        .map(([state, cities]) => cities.map((city: string) => ({ state, city }) as CityOption))
        .flat() || []
    );
  }, [filters.countries, locationData]);

  const handleChange = (event: any) => {
    const {
      target: { value, name },
    } = event;

    if (name === 'country') {
      return setFilters({ [name]: value, cities: [] });
    }

    setFilters({ [name]: value });
  };

  const handleCityChange = (value: string, remove: boolean) => {
    if (remove) {
      setFilters({ cities: filters.cities.filter((city) => city !== value) });
    } else {
      setFilters({ cities: [...filters.cities, value] });
    }
  };

  // useEffect(() => {
  //   console.log('OpportunitiesFilter Rendered');
  // });

  const modifiedCityOptions = cityOptions.reduce((acc, cur) => {
    if (!acc[cur.state]) {
      acc[cur.state] = [];
    }
    acc[cur.state].push(cur.city);
    return acc;
  }, {} as any);

  const statesFromCityOptions = Object.keys(modifiedCityOptions);

  return (
    <FilterCont container>
      <Grid container spacing={1}>
        <Grid item lg={3} md={6} xs={12}>
          {/* Categories */}
          <FilterSelect
            disabled
            MenuProps={{
              PaperProps: {
                style: {
                  minWidth: 200,
                },
              },
              // MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            multiple
            onChange={handleChange}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 14, color: COLORS.PRIMARY }}>
                <CustomTypography>Categories:</CustomTypography>
              </InputAdornment>
            }
            value={['All']}
            renderValue={(selected: any) => (
              <CustomTypography color="primary">
                {selected?.length === 0
                  ? 'All'
                  : selected?.length > 1
                    ? `${selected[0]} +${selected?.length - 1}`
                    : selected}
              </CustomTypography>
            )}
            name="categories"
          >
            {gender.map((g) => (
              <MenuItem key={g.value} value={g.value}>
                <Checkbox checked={['']?.indexOf(g.value as string) > -1} color="primary" />
                <ListItemText primary={g.value} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </FilterSelect>
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          {/* Job Type */}
          <FilterSelect
            native={false}
            displayEmpty={true}
            style={{ height: 40, flex: 1, paddingLeft: 0 }}
            MenuProps={{
              PaperProps: {
                style: {
                  minWidth: 200,
                },
              },
              // MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            multiple
            onChange={handleChange}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 14, color: COLORS.PRIMARY }}>
                <CustomTypography style={{ whiteSpace: 'nowrap' }}>Job Type:</CustomTypography>
              </InputAdornment>
            }
            value={filters.job_types || []}
            renderValue={(selected: any) => (
              <CustomTypography color="primary">
                {selected?.length === 0
                  ? 'All'
                  : selected?.length > 1
                    ? `${selected[0]} +${selected?.length - 1}`
                    : selected}
              </CustomTypography>
            )}
            name="job_types"
          >
            {jobType.map((g) => (
              <MenuItem key={g.value} value={g.value}>
                <Checkbox checked={filters.job_types?.indexOf(g.value as string) > -1} color="primary" />
                <ListItemText primary={g.value} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </FilterSelect>
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          {/* Gender */}
          <FilterSelect
            native={false}
            displayEmpty={true}
            style={{ height: 40, flex: 1, paddingLeft: 0 }}
            MenuProps={{
              PaperProps: {
                style: {
                  minWidth: 200,
                },
              },
              // MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            multiple
            onChange={handleChange}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 14, color: COLORS.PRIMARY }}>
                <CustomTypography style={{ whiteSpace: 'nowrap' }}>Gender:</CustomTypography>
              </InputAdornment>
            }
            value={filters.genders || []}
            renderValue={(selected: any) => (
              <CustomTypography color="primary">
                {selected?.length === 0
                  ? 'All'
                  : selected?.length > 1
                    ? `${selected[0]} +${selected?.length - 1}`
                    : selected}
              </CustomTypography>
            )}
            name="genders"
          >
            {gender.map((g) => (
              <MenuItem key={g.value} value={g.value}>
                <Checkbox checked={filters.genders?.indexOf(g.value as string) > -1} color="primary" />
                <ListItemText primary={g.value} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </FilterSelect>
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          {/* Paid */}
          <FilterSelect
            native={false}
            displayEmpty={true}
            style={{ height: 40, flex: 1, paddingLeft: 0 }}
            MenuProps={{
              PaperProps: {
                style: {
                  minWidth: 200,
                },
              },
              // MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            multiple
            onChange={handleChange}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 14, color: COLORS.PRIMARY }}>
                <CustomTypography style={{ whiteSpace: 'nowrap' }}>Paid:</CustomTypography>
              </InputAdornment>
            }
            value={filters.paying_roles || []}
            renderValue={(selected: any) => {
              return (
                <CustomTypography color="primary">
                  {selected?.length === 0
                    ? 'All'
                    : selected?.length > 1
                      ? `${selected[0]} +${selected?.length - 1}`
                      : selected}
                </CustomTypography>
              );
            }}
            name="paying_roles"
          >
            {['Yes', 'No', 'Deffered'].map((g) => (
              <MenuItem key={g} value={g}>
                <Checkbox checked={filters.paying_roles?.indexOf(g as string) > -1} color="primary" />
                <ListItemText primary={g} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </FilterSelect>
        </Grid>
      </Grid>
      <Grid container spacing={1}>
        {/* Age Range */}
        <Grid item lg={3} md={6} xs={12}>
          <AgeRangeButton onClick={openAgeRange}>
            <CustomTypography color="primary">
              <span style={{ marginRight: 10, color: isDark ? COLORS.WHITE : COLORS.BLACK }}>Age:</span>
              {filters.age_range_from} - {filters.age_range_to}
            </CustomTypography>
            <SelectArrowDownIcon
              style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
              htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
            />
          </AgeRangeButton>
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          {/* Country */}
          <FilterSelect
            style={{ height: 40, flex: 1, paddingLeft: 0 }}
            MenuProps={{
              PaperProps: {
                style: {
                  minWidth: 200,
                },
              },
              // MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            onChange={handleChange}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 14, color: COLORS.PRIMARY }}>
                <CustomTypography style={{ whiteSpace: 'nowrap' }}>Country:</CustomTypography>
              </InputAdornment>
            }
            value={filters.countries || []}
            renderValue={(selected: any) => <CustomTypography color="primary">{selected}</CustomTypography>}
            name="countries"
          >
            {Object.keys(locationData).map((g) => (
              <MenuItem key={g} value={g}>
                <ListItemText key={g} primary={g} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </FilterSelect>
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          {/* Cities */}
          <FilterSelect
            native={false}
            displayEmpty={true}
            style={{ height: 40, flex: 1, paddingLeft: 0 }}
            MenuProps={{
              PaperProps: {
                style: {
                  minWidth: 200,
                },
              },
              // MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            multiple
            // onChange={handleChange}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 14, color: COLORS.PRIMARY }}>
                <CustomTypography style={{ whiteSpace: 'nowrap' }}>Cities:</CustomTypography>
              </InputAdornment>
            }
            value={filters.cities || []}
            renderValue={(selected: any) => (
              <CustomTypography color="primary">
                {selected?.length === 0
                  ? 'All'
                  : selected?.length > 1
                    ? `${selected[0]} +${selected?.length - 1}`
                    : selected}
              </CustomTypography>
            )}
            name="cities"
          >
            {/* group cities and populate list using modified city options */}
            {statesFromCityOptions.map((state) => {
              //get the cities for matching state
              const cities = modifiedCityOptions[state];

              return (
                <div style={{ padding: '5px 15px' }} key={state}>
                  <CustomTypography color="primary" fontSize={16} fontWeight={500}>
                    {state}
                  </CustomTypography>
                  {cities.map((city: string) => (
                    <MenuItem
                      key={city}
                      value={city}
                      style={{ padding: 0, marginLeft: 5 }}
                      onClick={() =>
                        handleCityChange(city, filters.cities?.indexOf(city as string) > -1 ? true : false)
                      }
                    >
                      <Checkbox
                        checked={filters.cities?.indexOf(city as string) > -1}
                        color="primary"
                        name="cities"
                        value={filters.cities}
                      />
                      <ListItemText primary={city} style={{ textTransform: 'capitalize' }} />
                    </MenuItem>
                  ))}
                </div>
              );
            })}
          </FilterSelect>
        </Grid>
        <Grid item lg={3} md={6} xs={12}>
          {/* Union */}
          <FilterSelect
            displayEmpty={true}
            native={false}
            style={{ height: 40, flex: 1, paddingLeft: 0 }}
            MenuProps={{
              PaperProps: {
                style: {
                  minWidth: 200,
                },
              },
              // MenuListProps: { className: selectCls },
            }}
            IconComponent={() => (
              <SelectArrowDownIcon
                style={{ position: 'absolute', right: 0, top: 15, pointerEvents: 'none' }}
                htmlColor={isDark ? COLORS.WHITE : COLORS.BLACK}
              />
            )}
            variant="outlined"
            fullWidth
            multiple
            onChange={handleChange}
            startAdornment={
              <InputAdornment position="start" style={{ marginLeft: 14, color: COLORS.PRIMARY }}>
                <CustomTypography style={{ whiteSpace: 'nowrap' }}>Union:</CustomTypography>
              </InputAdornment>
            }
            value={filters.unions || []}
            renderValue={(selected: any) => (
              <CustomTypography color="primary">
                {selected?.length === 0
                  ? 'All'
                  : selected?.length > 1
                    ? `${selected[0]} +${selected?.length - 1}`
                    : selected}
              </CustomTypography>
            )}
            name="unions"
          >
            {unionList.map((g) => (
              <MenuItem key={g.value} value={g.value}>
                <Checkbox checked={filters.unions?.indexOf(g.value as string) > -1} color="primary" />
                <ListItemText primary={g.value} style={{ textTransform: 'capitalize' }} />
              </MenuItem>
            ))}
          </FilterSelect>
        </Grid>
      </Grid>

      {open ? <AgePopOver open={open} anchorEl={anchorEl} handleClose={handleClose} /> : null}
    </FilterCont>
  );
};

export default React.memo(OpportunitiesFilter);
